export enum FAIL_REASON {
  // 1: 服务端异常、2: 无网、3:取消、4:其他"
  SERVER_ERROR = 1,
  NO_NETWORK = 2,
  CANCEL = 3,
  OTHER = 4,
  OAUTH_ERROR = 5,
}

export enum LOGIN_RESULT_TYPE {
  SUCCESS = 1,
  FAIL = 2,
}
